import "./EditDataRetentionSettings.html";
import "./EditDataRetentionSettings.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";

import EditDataRetentionSettingsComponentController from "./EditDataRetentionSettingsComponentController";

export default class EditDataRetentionSettingsComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditDataRetentionSettingsComponentController;
        this.templateUrl = "/App/Components/Partners/Details/EditDataRetentionSettings/EditDataRetentionSettings.html";
    }
}

module("mmManagePortal").component("irEditDataRetentionSettings", new EditDataRetentionSettingsComponent());
